import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import VpnKeyIcon from '@material-ui/icons/VpnKey'
import Autocomplete from '@material-ui/lab/Autocomplete'
import React from 'react'
import { useActions, useValues } from 'kea';
import CircularProgress from '@material-ui/core/CircularProgress';

import keylogic from 'src/store/key'

const AssignKeyDialog = ({ vehicle, onKeyAssign }) => {
	// const [vehicle, setVehicle] = useState(props.vehicle);
	const [open, setOpen] = React.useState(false);

	const { keys } = useValues(keylogic);
	const { fetchAll: keyFetchAll } = useActions(keylogic);

	const [newKeys, setNewKeys] = React.useState(vehicle.keys);

	React.useEffect(() => {
		keys ?? keyFetchAll();
	}, []) // eslint-disable-line

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
		setNewKeys(vehicle.keys)
	}

	const handleChange = (e, newValue) => {
		// console.log(newValue)
		// const update_keys = newValue;
		// setNewKeys(update_keys);
		setNewKeys(newValue)
	}

	const handleEdit = () => {
		setOpen(false);
		// vehicle.keys = newKeys;
		// console.log(vehicle);
		// vehicle.tracker = tracker;
		onKeyAssign({ _id: vehicle._id, keys: newKeys.map(k => k._id) });
	}
	// console.log(keys, newKeys)
	if (keys === null) return <CircularProgress />

	return (
		<div>
			<Tooltip title="Assign Key(s) to this Vehicle">
				<IconButton aria-label="delete" onClick={handleClickOpen} size='small'>
					<VpnKeyIcon />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Assign this Key(s) to this Vehicle
					<Typography align="center" color="secondary">You need to have Driver Identification setup for your vehicle.</Typography>
				</DialogTitle>
				<DialogContent>
					<Autocomplete
						multiple
						id="tags-standard"
						options={keys.filter(key => !newKeys.find(nk => nk._id === key._id))}
						getOptionLabel={(option) => `${option.id} - ${option.name ? option.name : ''}`}
						// defaultValue={vehicle.groups}
						size={'medium'}
						value={newKeys}
						filterSelectedOptions
						onChange={handleChange}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Select Keys"
							// placeholder=""
							/>
						)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleEdit} color="primary">
						Assign
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default AssignKeyDialog
